var keyMirror = require('keymirror');

export const endPoints = {
    GET_PERMISSIONS: 'api/permissions/get',
};

export const Permissions = {
    SuperUser: 1,
    Administrator: 2,
    AssignAdmin: 3, //
    AssignPermissions: 4, //
    LogintoBackend: 5,
    LogintoPOS: 6,
    LogintoStorefront: 7,
    ViewPlants: 8, //
    ViewPlantGroups: 9, //
    AddPlants: 10, // ignored for now
    RetirePlants: 11, //
    MovePlants: 12, //
    AddPlantToHarvest: 13, //
    CreatePlants: 14, // Sidebar - Add Plants/Clones to Inventory
    CreatePlantGroup: 15, //
    AssignMother: 16, //
    AssignPlantGroup: 17, //
    AssignPlantStatus: 18, // Assign Plant Mother Status in Plant Manager
    ApplyNutrients: 19, //
    ViewPlantHistory: 20, // Journal and Nutrient Log
    ConvertPlants: 21, // Convert to Plant(s) in Plant Manager Action Menu
    EnterPlantWeights: 22, // Batch Manager harvest screen
    EnterWetWaste: 23, //
    EnterDryWaste: 24, //
    CloseHarvest: 25, // Batch Manager Action Menu
    CreateHarvestPackages: 26, //
    PostPackagesToInventory: 27, //
    TransferPlantToInventory: 28, //
    EnterLabResults: 29, //
    PrintPlantLabels: 30, //
    AssignPlantStage: 31, //
    ViewHarvest: 32, //
    ViewLabAnalysis: 33, //
    ViewPackaging: 34, //
    ViewInventory: 35, // Hide Inventory in sidebar
    ViewInventoryCosts: 36, //
    AdjustInventory: 37, //
    CreateBatch: 38, //
    AssignBatch: 39, //
    MoveInventory: 40, //
    CombineInventory: 41, //
    ConvertInventory: 42, //
    PrintInventoryLabels: 43, //
    ChangeInventoryProduct: 44, //
    CreatePackages: 45, // ??
    Sublot: 46, //
    DestroyInventory: 47, //
    ViewLabSamples: 48, //
    EditLabSamples: 49, //
    ViewInventoryTransactions: 50, //
    ViewInventoryHistory: 51, // ??
    UpdatePackageData: 52, //
    CreateInventoryPackages: 53, //
    ReceiveInventory: 54, //
    ViewReceiveHistory: 55, //
    SaveOrders: 56, //
    ReceiveTransfers: 57, //
    ViewIntegrationReconciliation: 58, //
    CreateReconciliation: 59, //
    EditReconciliation: 60, //
    EnterReconciliationData: 61, //
    CloseReconciliation: 62, //
    ViewReconciliation: 63,
    ViewBatchHistory: 64, // Sidebar - Inventory - Batch History

    // Inventory - Manifest
    CreateManifest: 65, //
    AddItemstoManifest: 66, //
    DeleteManifest: 67, //
    CloseManifest: 68, //
    EditManifest: 69, // Details - Drivers - Address - Delete items
    PrintManifest: 70, // Manifest - Invoice

    // Inventory - Recipes
    EditRecipe: 71, //
    ViewRecipes: 72, //

    // Inventory - Recipe Batches
    CreateRecipeBatch: 73, //
    ViewRecipeBatch: 74, //
    RunRecipeBatchSteps: 75, //
    UndoRecipeBatchSteps: 76, //

    CreateProduct: 77, //
    ViewProductDetail: 78, //
    EditProductDetail: 79, //

    ManageRetiredProducts: 80, //
    ViewPOSSummary: 81, //
    ViewRegisterTransactionData: 82, //
    AdjustRegister: 83, //
    CloseOutRegister: 84, //
    ViewClosingReport: 85, //
    ViewPOS: 86,
    ViewDashboard: 87, //
    ViewStaticReports: 88, //
    ViewReportBuilder: 89, //
    SaveReports: 90, //

    ViewCustomers: 91, //
    EditCustomers: 92, //
    EditCars: 93, //
    EditDrivers: 94, //
    ConfigureLabels: 95, //
    EditRooms: 96, //
    ConfigurePrinters: 97, //
    EditProductCategories: 98, //
    EditStrains: 99, //
    EditVendors: 100, //
    EditTables: 101, //
    EditReasonCodes: 102, //
    EditTimeClocks: 103, //
    EditUsers: 104, //
    ConfigureReceipts: 105, //
    ViewManifest: 106,
    ViewWasteManager: 107,
    ViewProductMaster: 108,
    EditInventoryStatus: 109,
    EditDiscounts: 110,
    EditDiscountGroups: 111,
    EditDoctors: 112,
    EditPricing: 113,
    EditRegisters: 114,
    EditTaxRates: 116,
    DiscontinuePackage: 117,
    POSManager: 118,
    MergeCustomers: 119,
    SetHarvestStage: 120,
    AssignUsersToGroups: 121,
    ResetUserPasswords: 122,
    ViewPermissions: 123,
    BackDatePlantActions: 124,
    ViewPackageHistory: 125,
    BypassStateSystem: 126,
    OverrideDiscounts: 127,
    EditReturnReasons: 128,
    EditPackageIdFormat: 129,
    EditReceivedProductDetails: 140,
    ViewInfusions: 141,
    EditInfusion: 142,
    RegisterTransfer: 143,
    EditProductSkuFormat: 144,
    EditTransactionAdjustmentReasons: 145,
    ViewBIDashboard: 146,
    ExploreBIData: 147,
    ExlopreBIEnterpriseData: 148,
    EditPOSCustomerStatus: 149,
    EditPatientJournalEntries: 150,
    EditLocationProductMaster: 151,
    EditBrands: 152,
    EditFeesDonations: 156,
    EditDiscountGroupCustomers: 261,

    // Users -  Integrations
    ViewQuickbooksIntegration: 157,
    EditQuickbooksIntegration: 158,
    ViewSproutIntegration: 159,
    EditSproutIntegration: 160,
    ViewWeedmaps2Integration: 161,
    EditWeedmaps2Integration: 162,
    ViewHypurIntegration: 163,
    EditHypurIntegration: 164,
    ViewMETRCIntegration: 165,
    EditMETRCIntegration: 166,
    ViewBioTrackIntegration: 167,
    EditBioTrackIntegration: 168,
    ViewWeedMapsIntegration: 169,
    EditWeedMapsIntegration: 170,
    ViewLeaflyIntegration: 171,
    EditLeaflyIntegration: 172,
    ViewMassDHIntegration: 173,
    EditMassDHIntegration: 174,
    ViewSpringBigIntegration: 175,
    EditSpringBigIntegration: 176,
    ViewLinxIntegration: 177,
    EditLinxIntegrations: 178,
    ViewMNIntegration: 179,
    EditMNIntegration: 180,
    ViewLeafIntegration: 181,
    EditLeafIntegration: 182,
    ViewOnFleetIntegration: 183,
    EditOnFleetIntegration: 184,
    ViewTookanIntegration: 185,
    EditTookanIntegration: 186,
    ScheduleEmailReports: 187,
    EditVaultRegister: 188,
    ViewVaultRegister: 291,
    BiotrackDestructionManager: 192,
    EditLineages: 193,
    EditDistillations: 194,
};

export const actions = keyMirror({});

export const events = keyMirror({
    CHANGE_EVENT: null,
});



// WEBPACK FOOTER //
// ./ui_src/app/constants/PermissionConstants.jsx